module.exports = __webpack_public_path__ + "static/media/in_a_week_sample_6.88a2f497.jpg";